import React, { useEffect, useState } from 'react';
import {
  Header as HeaderStyled,
  HeaderLeft,
  MenuToggle,
  PageTitle,
  HeaderRight,
  HeaderActions,
  NotificationButton,
  NotificationBadge,
  SearchBox,
  SearchInput,
  SearchButton,
  ProfileSection,
  ProfileInfo,
  ProfileAvatar,
  ProfileDetails,
  ProfileName,
  ProfileEmail,
  ProfileMenuButton,
  ProfileDropdown,
  DropdownItem,
  DropdownIcon,
  DropdownDivider,
  NotificationsDropdown,
  NotificationHeader,
  NotificationTitle,
  MarkAllReadButton,
  NotificationList,
  NotificationItem,
  NotificationIcon,
  NotificationContent,
  NotificationItemTitle,
  NotificationText,
  NotificationTime
} from '../styles/HeaderStyles';
import { MyAccounts } from '../common/CommonApi';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess, logout } from '../store/slices/auth';
import { ComponentUpdate } from '../store/slices/component';
import { useNavigate } from "react-router-dom";
const Header = ({ activePage, sidebarCollapsed }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const dispatch = useDispatch()

  const admins = useSelector((state) => state.auth);
  const getPageTitle = () => {
    const titles = {
      dashboard: 'Dashboard',
      users: 'Users Management',
      products: 'Products',
      orders: 'Orders',
      analytics: 'Analytics',
      settings: 'Settings',
      coupons: 'Coupons',
      Access: 'Access',
      Banner: 'Banner'
    };
    return titles[activePage] || 'Dashboard';
  };
  useEffect(() => {
    GetMyAccount()
  }, [])

  async function GetMyAccount() {
    let obj = await MyAccounts()
    dispatch(loginSuccess(
      {
        _id: obj._id,
        permissions: obj.permissions,
        email: obj.email,
        role: obj.role,
        fullname: obj.fullname,
        token: admins.token,
        refreshToken: admins.refreshToken,
      }
    ))
  }

  function logOut() {
    dispatch(
      logout()
    )
  }
  const navigate = useNavigate()

  return (
    <HeaderStyled>
      <HeaderLeft>
        <MenuToggle onClick={() =>
          // setSidebarCollapsed(!sidebarCollapsed)
          dispatch(
            ComponentUpdate({ isSideBar: !sidebarCollapsed })
          )
        }
        >
          ☰
        </MenuToggle>
        <PageTitle>{getPageTitle()}</PageTitle>
      </HeaderLeft>

      <HeaderRight>
        <HeaderActions>
          {/* <NotificationButton onClick={() => setShowNotifications(!showNotifications)}>
            🔔
            <NotificationBadge>3</NotificationBadge>
          </NotificationButton> */}

          {/* <SearchBox>
            <SearchInput type="text" placeholder="Search..." />
            <SearchButton>🔍</SearchButton>
          </SearchBox> */}
        </HeaderActions>

        <ProfileSection>
          <ProfileInfo>
            <ProfileAvatar>👤</ProfileAvatar>
            <ProfileDetails>
              <ProfileName>{admins && admins.fullname}</ProfileName>
              <ProfileEmail>{admins && admins.email}</ProfileEmail>
              <ProfileEmail>{admins && admins.role}</ProfileEmail>
            </ProfileDetails>
          </ProfileInfo>

          <ProfileMenuButton onClick={() => setShowProfileMenu(!showProfileMenu)}>
            ⚙️
          </ProfileMenuButton>

          {showProfileMenu && (
            <ProfileDropdown>
              {/* <DropdownItem>
                  <DropdownIcon onClick={() => navigate('/settings')}>
                    👤
                  </DropdownIcon>
                <span>Profile</span>
              </DropdownItem> */}
               {/* <DropdownItem onClick={() => navigate('/profile')}>
                <DropdownIcon>👤</DropdownIcon>
                <span>Profile</span>
              </DropdownItem> */}
              {/* <DropdownItem>
                <DropdownIcon>⚙️</DropdownIcon>
                <span>Settings</span>
              </DropdownItem> */}
              <DropdownItem onClick={() => navigate('/settings')}>
                <DropdownIcon>⚙️</DropdownIcon>
                <span>Settings</span>
              </DropdownItem>
              <DropdownDivider />
              <DropdownItem onClick={() => logOut()}>
                <DropdownIcon>🚪</DropdownIcon>
                <span>Logout</span>
              </DropdownItem>
            </ProfileDropdown>
          )}
        </ProfileSection>
      </HeaderRight>

      {showNotifications && (
        <NotificationsDropdown>
          <NotificationHeader>
            <NotificationTitle>Notifications</NotificationTitle>
            <MarkAllReadButton>Mark all as read</MarkAllReadButton>
          </NotificationHeader>
          <NotificationList>
            <NotificationItem>
              <NotificationIcon>🛒</NotificationIcon>
              <NotificationContent>
                <NotificationItemTitle>New Order</NotificationItemTitle>
                <NotificationText>Order #1234 has been placed</NotificationText>
                <NotificationTime>2 minutes ago</NotificationTime>
              </NotificationContent>
            </NotificationItem>
            <NotificationItem>
              <NotificationIcon>👥</NotificationIcon>
              <NotificationContent>
                <NotificationItemTitle>New User</NotificationItemTitle>
                <NotificationText>A new user has registered</NotificationText>
                <NotificationTime>5 minutes ago</NotificationTime>
              </NotificationContent>
            </NotificationItem>
            <NotificationItem>
              <NotificationIcon>📦</NotificationIcon>
              <NotificationContent>
                <NotificationItemTitle>Low Stock</NotificationItemTitle>
                <NotificationText>Product "T-Shirt" is running low</NotificationText>
                <NotificationTime>1 hour ago</NotificationTime>
              </NotificationContent>
            </NotificationItem>
          </NotificationList>
        </NotificationsDropdown>
      )}
    </HeaderStyled>
  );
};

export default Header;
